import React from 'react';
import { Helmet } from 'react-helmet-async';
import { HowWeWork } from '../../components/features';

const HowWeWorkPage = () => {
  return (
    <>
      <Helmet>
        <title>How We Work - HSP Home Services | Subscription-Based Home Maintenance</title>
        <meta name="description" content="Discover how HSP's subscription-based home maintenance model saves you money through preventative care. One phone number for all services - affordable, reliable, and stress-free home maintenance for busy homeowners, landlords, and seniors." />
        <meta name="keywords" content="home maintenance subscription, preventative home care, affordable home services, property maintenance plans, home service packages, landlord property maintenance, senior home care, subscription home services, Bay Area home maintenance" />
        
        {/* Open Graph / Social Media */}
        <meta property="og:title" content="How We Work - Subscription Home Maintenance | HSP" />
        <meta property="og:description" content="Save up to 70% on home repairs with preventative maintenance. One subscription covers all your exterior home services." />
        <meta property="og:type" content="website" />
        
        {/* SEO Schema Markup */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "Home Maintenance Subscription Service",
            "provider": {
              "@type": "LocalBusiness",
              "name": "HSP - Hammer Saw Paint",
              "telephone": "888-504-6944",
              "priceRange": "$99-$249",
              "areaServed": "San Francisco Bay Area"
            },
            "description": "Subscription-based preventative home maintenance service. One phone number for all exterior home services including lawn care, gutter cleaning, window washing, and more.",
            "offers": {
              "@type": "AggregateOffer",
              "priceCurrency": "USD",
              "lowPrice": "99",
              "highPrice": "249",
              "priceSpecification": {
                "@type": "UnitPriceSpecification",
                "price": "99-249",
                "priceCurrency": "USD",
                "billingDuration": "P1M"
              }
            },
            "audience": [
              {
                "@type": "Audience",
                "audienceType": "Busy Homeowners and Working Professionals"
              },
              {
                "@type": "Audience", 
                "audienceType": "Property Investors and Landlords"
              },
              {
                "@type": "Audience",
                "audienceType": "Senior Homeowners"
              }
            ]
          })}
        </script>
      </Helmet>
      <HowWeWork />
    </>
  );
};

export default HowWeWorkPage;
